module.exports = __webpack_public_path__ + "static/img/qrcode0818.7bb698d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/qrcode0818.jpg
// module id = GqQP
// module chunks = 14